import React from "react";
import Page from "./Page";
import { useAuth } from "../../firebase/AuthProvider";
import Spinner from "../shared/Spinner";
import AchievementNotification from "../achievements/Notification";
import { Grid } from "@material-ui/core";

export default function App() {
  const { initializing } = useAuth();

  return (
    <Grid container>
      <Spinner isVisible={initializing} />
      <AchievementNotification />
      <Page />
    </Grid>
  );
}
